import { toInteger } from 'lodash-es';
export function splitVisitorId(visitorId) {
    if (visitorId == undefined) {
        return {};
    }
    try {
        return {
            createdAt: new Date(toInteger(visitorId.substring(0, 10)) * 1000),
            trackingString: visitorId.substring(10, 20)
        };
    } catch (e) {
        return {};
    }
}
